import { METHOD } from "./method";

export const API_EMPLOYEE_ANALYTICS = {
    LIST_JOB_UNIT: {
        api: '/v1/hr-adm/analytic/list-job-unit',
        method: METHOD.POST
    },
    DEPARTMENT_HAPPINESS_INDEX: {
        api: '/v1/hr-adm/analytic/happiness-index/departments',
        method: METHOD.POST
    },
    COMPANY: {
        api: '/v1/hr-adm/analytic/list-company',
        method: METHOD.GET
    },
    EMPLOYEE_STATUS: {
        api: '/v1/hr-adm/analytic/employee-status',
        method: METHOD.POST
    },
    LENGTH_OF_SERVICE: {
        api: '/v1/hr-adm/analytic/length-of-service',
        method: METHOD.POST
    },
    JOB_LEVEL: {
        api: '/v1/hr-adm/analytic/job-level',
        method: METHOD.POST
    },
    GENDER_DIVERSITY: {
        api: '/v1/hr-adm/analytic/gender',
        method: METHOD.POST
    },
    TURNOVER: {
        api: '/v1/hr-adm/analytic/turnover',
        method: METHOD.POST
    },
    LEAVE_UTILIZATION: {
        api: '/v1/hr-adm/analytic/leave',
        method: METHOD.POST
    },
    HAPPINESS_INDEX: {
        api: '/v1/hr-adm/analytic/happiness-index',
        method: METHOD.POST
    },
    EMPLOYEE_PRODUCTIVITY: {
        api: '/v1/hr-adm/analytic/employee-productivity',
        method: METHOD.POST
    },
    INTERNAL_MOVEMENT: {
        api: '/v1/hr-adm/analytic/internal-movement',
        method: METHOD.POST
    },
    NINE_BOX_PERFORMANCE_TREND: {
        api: '/v1/hr-adm/analytic/nine-box/performance-trend',
        method: METHOD.POST
    },
    NINE_BOX_TALENT_MATRIX: {
        api: '/v1/hr-adm/analytic/nine-box/talent-matrix',
        method: METHOD.POST
    },
}